import { useMemo } from "react";
import { Typography } from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import StoreIcon from "@mui/icons-material/Store";
import { Trans } from "react-i18next";
import { useResource, Resources } from "Translations/Resources";
import { VerticalTimeline } from "Components/Shared/VerticalTimeline/VerticalTimeline";
import type { TimelineStep } from "Components/Shared/VerticalTimeline/types";

const RESOURCES = Resources.Campaigns.Campaign.TimelineSteps;

type Props = {
  campaignName: string;
  inactiveColor?: string;
  paymentInstructions?: string | null;
  onlyWithMoone?: string | null;
};

export const CampaignTimeline = ({
  campaignName,
  inactiveColor,
  paymentInstructions,
  onlyWithMoone,
}: Props) => {
  const { t } = useResource();

  const timelineSteps: ReadonlyArray<TimelineStep> = useMemo(
    () => [
      {
        id: "1",
        title: t(RESOURCES.Donate.Title),
        isCompleted: true,
        icon: <ListIcon />,
      },
      {
        id: "2",
        title: t(RESOURCES.JoinTeam.Title, { campaignName }),
        description: (
          <Trans components={{ newline: <br /> }}>
            {t(RESOURCES.JoinTeam.Description, { campaignName })}
          </Trans>
        ),
        isCompleted: false,
        icon: <ListIcon />,
      },
      {
        id: "3",
        title: t(RESOURCES.PayAtCafe.Title),
        description: paymentInstructions ? (
          <Typography sx={{ whiteSpace: "pre-wrap" }}>
            {paymentInstructions}
          </Typography>
        ) : t(RESOURCES.PayAtCafe.Description) ? (
          <Trans components={{ newline: <br /> }}>
            {t(RESOURCES.PayAtCafe.Description)}
          </Trans>
        ) : undefined,
        isCompleted: false,
        icon: <LocalCafeIcon />,
      },
      {
        id: "4",
        title: t(RESOURCES.AnyMethod.Title),
        description: onlyWithMoone ? (
          <Typography sx={{ whiteSpace: "pre-wrap" }}>
            {onlyWithMoone}
          </Typography>
        ) : t(RESOURCES.AnyMethod.Description) ? (
          <Trans components={{ newline: <br /> }}>
            {t(RESOURCES.AnyMethod.Description)}
          </Trans>
        ) : undefined,
        isCompleted: false,
        icon: <StoreIcon />,
      },
    ],
    [t, campaignName, paymentInstructions, onlyWithMoone],
  );

  return (
    <VerticalTimeline steps={timelineSteps} inactiveColor={inactiveColor} />
  );
};
